import { render } from "./SettingsApiTokens.vue?vue&type=template&id=160e628d"
import script from "./SettingsApiTokens.vue?vue&type=script&lang=js"
export * from "./SettingsApiTokens.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__